import { cn } from "../lib/cn";

export type EnvironmentNotchProps = {
  label: string | null | undefined;
  className?: string;
};

export function EnvironmentNotch({ label, className }: EnvironmentNotchProps) {
  if (!label) return null;

  return (
    <div
      aria-label={`Current environment: ${label}`}
      className={cn("pointer-events-none fixed inset-x-0 top-0 z-[2147483647]", className)}
      role="status"
    >
      <div className="h-1 bg-red-600/90 shadow-[0_1px_10px_rgba(220,38,38,0.42)]" />
      <div className="absolute left-1/2 top-0 -translate-x-1/2 rounded-b-xl border-x border-b border-red-300/45 bg-red-600 px-7 py-1.5 text-[0.64rem] font-black uppercase tracking-[0.32em] text-white shadow-[0_10px_28px_rgba(127,29,29,0.3)]">
        {label}
      </div>
    </div>
  );
}
